export const STAGE_TONE: Record<string, "slate" | "blue" | "violet" | "amber" | "green" | "red"> = {
  new: "slate",
  contacted: "blue",
  counselling_booked: "blue",
  assessed: "violet",
  recommendation_ready: "violet",
  proposal_sent: "amber",
  won: "green",
  nurture: "amber",
  lost: "red",
};

export const STAGE_LABEL: Record<string, string> = {
  new: "New",
  contacted: "Contacted",
  counselling_booked: "Counselling booked",
  assessed: "Assessed",
  recommendation_ready: "Recommendation ready",
  proposal_sent: "Proposal sent",
  won: "Won / paid",
  nurture: "Nurture",
  lost: "Lost",
};

export const BOARD_STAGES = [
  "new",
  "contacted",
  "counselling_booked",
  "assessed",
  "recommendation_ready",
  "proposal_sent",
  "won",
];

export const ROLE_LABEL: Record<string, string> = {
  admin: "Admin",
  manager: "Manager",
  counsellor: "Counsellor",
  delivery: "Delivery owner",
  finance: "Finance",
};

export const GRADES = [
  ...Array.from({ length: 7 }, (_, i) => `Class ${i + 6}`),
  "Gap year",
  "Undergraduate",
];
